export const GetCalendarEntriesLOADING = "getCalendarEntries/Loading";
export const GetCalendarEntriesSUCCESS = "getCalendarEntries/Success";
export const GetCalendarEntriesERROR = "getCalendarEntries/Error";
export const CreateCalendarEntrySUCCESS = "createCalendarEntry/Success";
export const UpdateCalendarEntrySUCCESS = "updateCalendarEntry/Success";
export const DeleteCalendarEntrySUCCESS = "deleteCalendarEntry/Success";
